/**
 * API URL utility for AkountFly
 * 
 * Provides the correct API base URL regardless of environment.
 * In production, uses relative URLs so the app works on any domain.
 * In local dev, uses REACT_APP_BACKEND_URL from .env.
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const isLocalDev = typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

/** Base URL for API calls (e.g., "/api" or "https://preview-url.com/api") */
export const API_BASE = isLocalDev ? `${BACKEND_URL}/api` : '/api';

/** Raw backend URL (e.g., "" or "https://preview-url.com") */
export const BACKEND_BASE = isLocalDev ? BACKEND_URL : '';
